export const BASE_SERVER_URL = import.meta.env.DEV ? 'http://localhost:3000' : 'https://kjapt-valg.herokuapp.com'
export const BASE_WEBSITE_URL = import.meta.env.DEV ? 'http://localhost:5173' : 'https://kjapt-valg.vitterso.net'

export function getQueryParameter(key: string) {
  return (new URLSearchParams(window.location.search)).get(key)
}